import React from "react";

const fm = new Intl.NumberFormat("es-MX", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const ColName = ({ col }) => {
  if (col === "Unidad") return col;
  if (col === "Total") return col;

  return (
    <span className="text-center">
      Día <br />
      {col}
    </span>
  );
};

const Columns = (columnas) => {
  let columns = [];

  if (columnas) {
    columnas.map((col) => {
      const right = columns.push({
        id: `${col}`,
        name: <ColName col={col} />,
        cell: (row) => {
          if (col === "Total") return `$ ${fm.format(row[col] ?? 0)}`;

          return <div>{row[col] ? row[col] : "-"}</div>;
        },
        sortable: false,
        ...(col === "Total" ? { right: true } : { center: true }),
      });
    });
  }

  return columns;
};

export default Columns;
